import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'


export const NotFound = () => {
  const { t } = useTranslation()

  return (
    <div>
      <div id="container">
        <div className="sub_title">
          <div className="sub_title_txt">
            <span className="depth2">Page Not Found</span>
            <span className="desc">EARTHQUAKE RESEARCH INFORMATION</span>
          </div>
        </div>
        <div className="page_nav">
          <div className="container page_location">
            <ul className="menu_list">
              <li className="left home"><Link to="/"><i className="ion ion-md-home"></i></Link></li>
              </ul>
            </div>
        </div>
      </div>
      <div className="container">
        <div className="sub-container">
          <h3>{t('page.notFound.pageNotFound')}</h3>
          <span><Link to="/">{t('page.notFound.goToHome')}</Link></span>     
        </div>
      </div>
    </div>
  );
}